import { EActiveRoomType } from '../shared/repositories/newbuilding-genplan-mvk/entities/get_floor_plan/FloorPlanSchema';
export var ROOM_TYPES_OPTIONS = [{
  value: EActiveRoomType.Studio,
  label: 'Студия'
}, {
  value: EActiveRoomType.OneRoom,
  label: '1'
}, {
  value: EActiveRoomType.TwoRoom,
  label: '2'
}, {
  value: EActiveRoomType.ThreeRoom,
  label: '3'
}, {
  value: EActiveRoomType.FourRoom,
  label: '4'
}, {
  value: EActiveRoomType.FiveRoom,
  label: '5'
}, {
  value: EActiveRoomType.Large,
  label: '6+'
}, {
  value: EActiveRoomType.OpenPlan,
  label: 'Своб. планировка'
}];
export var FILTER_DEBOUNCE_TIME = 300;
export var FLOORS_PAGE_LIMIT = 23;
export var FLOORS_ITEM_WIDTH = 44;
export var FLOORS_PAGE_ANIMATION_DURATION = 400;